import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { Form } from '../components/Form';

import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const LoanExpiring = ({hibisId}) => {

  return (
    <>
      <Header />
      <Hero image="oskar-pred-iztekom.jpg" xPos="71%" yPos="28%" />
      <div className="addiko-app">
        <Container>
            <Row>
                <Col md={6} className="p-3">
                    <h1>Vaš kredit se izteka – mi smo pripravljeni!</h1>
                    <p className="text-left">
                      Vaš obstoječi kredit se bliža zaključku.
                    </p>
                    <p className="text-left red-text">
                      To pomeni, da je sedaj pravi trenutek, da uredite nov Addiko kredit in brez skrbi nadaljujete z vašimi finančnimi načrti.
                    </p>
                    <p className="text-left">
                      Ohranite finančno stabilnost brez prekinitev. <b>Izpolnite obrazec in kmalu vas bomo poklicali.</b>
                    </p>
                    <p className="text-left text-small">
                        Kjerkoli in kadarkoli, vedno z vami!<br />
                        Addiko banka
                    </p>
                </Col>
                <Col md={1} className="p-3 d-none d-md-block">
                    &nbsp;
                </Col>
                <Col md={5} className="p-3">
                  <Form guid="a247eab1-e16a-45fa-b2c9-53a7dca8f4b6" hibisId={hibisId} />
                </Col>
            </Row>
        </Container>
      </div>      
      <Footer />
    </>
  );
}